import Swiper from 'swiper';
import { StickyBackgroundFakeClickEvent } from './sticky-background';

export default function initTabs() : void {
    const $tabsContainers = document.querySelectorAll<HTMLElement>('.js-tabs');

    $tabsContainers.forEach($container => {
        new Tabs($container);
    });
}

type tabOptionsType = { $tab: HTMLElement, $target: HTMLElement, tabIndex: number };
export class Tabs {
    $container: HTMLElement;
    tabsOptions: tabOptionsType[] = [];
    $select: HTMLInputElement;
    swiper: Swiper;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$select = this.$container.querySelector('.js-tabs-select');
        const $tabs = this.$container.querySelectorAll<HTMLElement>('.js-tab');
        this.swiper = new Swiper(this.$container.querySelector<HTMLElement>('.js-tabs-targets'), {
            loop: true,
            autoHeight: true,
            simulateTouch: false,
        });

        $tabs.forEach(($tab, tabIndex) => {
            const targetId = $tab.getAttribute('data-target');
            if (!targetId) {
                console.error('Attribute data-target must be set.', $tab);
                return;
            }

            const $target = this.$container.querySelector<HTMLElement>(`.js-tab-target[data-target="${targetId}"]`);
            if (!$target) {
                console.error(`Targetted element ".js-tab-target[data-target=${targetId}]" doesn't exists.`, $tab);
                return;
            }

            this.tabsOptions.push({ $tab, $target, tabIndex });
        });

        if (this.tabsOptions.length > 0) {
            this.bindEvents();

            // Display the first tab
            this.tabsOptions[0].$tab.dispatchEvent(StickyBackgroundFakeClickEvent);
            this.swiper.slideTo(this.tabsOptions[0].tabIndex + 1);
            this.changeTab(this.tabsOptions[0]);
        }
    }

    /**
     * Bind events on tabs
     * 
     * @return {void}
     */
    bindEvents() : void {
        this.tabsOptions.forEach(tabOptions => {
            tabOptions.$tab.addEventListener('click', () => {
                this.swiper.slideTo(tabOptions.tabIndex + 1);

                this.changeTab(tabOptions);
            });
        });

        if (this.$select) {
            this.$select.addEventListener('change', () => {
                const tabOptions = this.tabsOptions[this.$select.value];
                this.swiper.slideTo(tabOptions.tabIndex + 1);
                tabOptions.$tab.dispatchEvent(StickyBackgroundFakeClickEvent);

                this.changeTab(tabOptions);
            });
        }

        this.swiper.on('slideChange', () => {
            const tabOptions = this.tabsOptions[this.swiper.realIndex];
            tabOptions.$tab.dispatchEvent(StickyBackgroundFakeClickEvent);

            this.changeTab(tabOptions);
        });
    }

    /**
     * Callback after having changed tab
     * 
     * @param {tabOptionsType} tabOptions 
     * 
     * @return {void}
     */
    changeTab(tabOptions: tabOptionsType) : void {
        this.tabsOptions.forEach(options => {
            if (options.tabIndex === tabOptions.tabIndex) {
                options.$tab.classList.add('active');
            } else {
                options.$tab.classList.remove('active');
            }
        });

        if (this.$select && this.$select.value !== `${tabOptions.tabIndex}`) {
            this.$select.value = '' + tabOptions.tabIndex;
        }
    }
}
